import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    VoteEntityMutation,
    VoteEntityMutationVariables,
} from "./__graphql-types__/VoteEntityMutation.ts";

export const VOTE_ENTITY_MUTATION: GqlOperation<
    VoteEntityMutation,
    VoteEntityMutationVariables
> = gqlOp(gql`
    mutation VoteEntityMutation($postKey: String!, $voteType: Int!) {
        voteEntity(entityKey: $postKey, voteType: $voteType) {
            error {
                code
            }
        }
    }
`);
